export const toInputValue = (date: Date) => {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const subtractMonths = (date: Date, months: number) => {
    const d = new Date(date);
    const targetMonth = d.getMonth() - months;
    const year = d.getFullYear() + Math.floor(targetMonth / 12);
    let month = ((targetMonth % 12) + 12) % 12;
    const day = d.getDate();
    const endOfTargetMonth = new Date(year, month + 1, 0).getDate();
    const safeDay = Math.min(day, endOfTargetMonth);
    return new Date(year, month, safeDay, d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
};


